import { Heading } from '@lmc/ui-kit/src/general'
import { Divider } from 'antd'
import { NAMESPACE } from 'locale'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { RevisionHistoryItem } from './RevisionHistoryItem'

export type ChangelogEntry = {
  changedAt: Date | string
  changedBy: {
    id: string
    name: {
      first: string
      last: string
    }
    picture?: string
  }
  changes: Record<string, { old: any; new: any }>
}

type RevisionHistorySectionProps = {
  changelog?: ChangelogEntry[]
  isDisposal?: boolean
  isRestock?: boolean
  isAdministration?: boolean
}

export const RevisionHistorySection = ({
  changelog,
  isDisposal,
  isRestock,
  isAdministration
}: RevisionHistorySectionProps) => {
  const { t } = useTranslation(NAMESPACE.EMAR_V2)
  if (!changelog || changelog.length === 0) {
    return null
  }

  const sortedChangelog = [...changelog].sort(
    (a, b) => new Date(b.changedAt).getTime() - new Date(a.changedAt).getTime()
  )

  return (
    <>
      <StyledDivider />
      <Container>
        <SectionHeader>
          <SectionTitle level={3}>{t('REVISION')}</SectionTitle>
        </SectionHeader>
        <RevisionsList>
          {sortedChangelog.map((entry, index) => (
            <RevisionHistoryItem
              key={`${entry.changedBy.id}-${entry.changedAt}-${index}`}
              entry={entry}
              isDisposal={isDisposal}
              isRestock={isRestock}
              isAdministration={isAdministration}
            />
          ))}
        </RevisionsList>
      </Container>
    </>
  )
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

const StyledDivider = styled(Divider)`
  margin: 16px 0;
`

const SectionHeader = styled.div`
  display: flex;
  align-items: center;
`

const SectionTitle = styled(Heading)`
  color: ${({ theme }) => theme.color.neutral.color3};
`

const RevisionsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`
